// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubaccountReport__subaccountReport___fYqqb {
  padding: 20px;
}

.SubaccountReport__body___VDdwv {
  margin-top: 20px;
}

.SubaccountReport__form___Pgetf {
  padding: 20px;
}

.SubaccountReport__formItemMono___jL3KD {
}

.SubaccountReport__input___C2Jir {
}

.SubaccountReport__label___gzwgM {
}

.SubaccountReport__reports___jIOBz {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 300px;
  margin-top: 20px;
}

.SubaccountReport__reports___jIOBz button {
  padding: 12px 20px;
  background-color: #376EA1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.SubaccountReport__reports___jIOBz button:hover {
  background-color: #3D6183;
}

.SubaccountReport__reports___jIOBz button:active {
  background-color: #3D6183;
}

.SubaccountReport__reports___jIOBz button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/SubaccountReport/SubaccountReport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".subaccountReport {\n  padding: 20px;\n}\n\n.body {\n  margin-top: 20px;\n}\n\n.form {\n  padding: 20px;\n}\n\n.formItemMono {\n  composes: formItemMono from 'styles/helpers.css';\n}\n\n.input {\n  composes: input from 'styles/helpers.css';\n}\n\n.label {\n  composes: label from 'styles/helpers.css';\n}\n\n.reports {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  max-width: 300px;\n  margin-top: 20px;\n}\n\n.reports button {\n  padding: 12px 20px;\n  background-color: #376EA1;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.reports button:hover {\n  background-color: #3D6183;\n}\n\n.reports button:active {\n  background-color: #3D6183;\n}\n\n.reports button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subaccountReport": `SubaccountReport__subaccountReport___fYqqb`,
	"body": `SubaccountReport__body___VDdwv`,
	"form": `SubaccountReport__form___Pgetf`,
	"formItemMono": `SubaccountReport__formItemMono___jL3KD ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItemMono"]}`,
	"input": `SubaccountReport__input___C2Jir ${___CSS_LOADER_ICSS_IMPORT_0___.locals["input"]}`,
	"label": `SubaccountReport__label___gzwgM ${___CSS_LOADER_ICSS_IMPORT_0___.locals["label"]}`,
	"reports": `SubaccountReport__reports___jIOBz`
};
export default ___CSS_LOADER_EXPORT___;
